export const MINIMUM_NUMBER_OF_CHARACTERS_TO_SEARCH = 2;

export const TYPE_SUCCESS = "success";
export const TYPE_INFO = "info";
export const TYPE_ERROR = "error";
